import type { IconSvgObject } from './types';

const Airplane02Icon: IconSvgObject = [
  ["path", { d: "M10 10.5L4 7L5.34281 5.60094C5.85877 5.08498 6.60996 4.8819 7.31562 5.0676L13 6.5M13.5 14L17 20L18.3991 18.6572C18.915 18.1412 19.1181 17.39 18.9324 16.6844L17.5 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.6614 4.82296L7.51755 13.4707L4.50585 12.9688L3 14.4746L7.51755 16.4824L9.52535 21L11.0312 19.4941L10.5293 16.4824L19.177 9.33862C20.8944 7.9199 21.4714 5.53901 20.5939 3.4915L20.5683 3.43175L20.5085 3.40614C18.461 2.52864 16.0801 3.10555 14.6614 4.82296Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Airplane02Icon;
